import type { KeyInitiative } from 'partner360/entities/keyInitiatives'

type TInitiativePlanScope = Pick<
  KeyInitiative,
  'EntryId' | 'Parent' | 'PartnerId' | 'FYear' | 'ProgramType'
>

interface IPlanScope {
  partnerId: string
  fYear: number
  programType: string
  entryId?: number
}

export const getOtherKeyInitiativesForPlan = <T extends TInitiativePlanScope>(
  initiatives: readonly T[],
  { partnerId, fYear, programType, entryId }: IPlanScope
): T[] =>
  initiatives.filter(
    (initiative) =>
      // Parent distinguishes actual initiatives from aggregate rows in the procedure response.
      Boolean(initiative.Parent) &&
      initiative.PartnerId === partnerId &&
      initiative.FYear === fYear &&
      (!initiative.ProgramType?.trim() || initiative.ProgramType === programType) &&
      initiative.EntryId !== entryId
  )
